import PopupActions from "./popupActions";

const initialState = {
  displayPopupWelcome: false,
  displayPopupCity: false,
  displayPopupPlot: false,
  selectedPlot: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case PopupActions.welcomeOpen:
      return {
        displayPopupWelcome: true,
        displayPopupCity: false,
        displayPopupPlot: false,
        displayPopupMyLands: false,
        displayPopupWallet: false,
        displayPopupAbout: false,
        displayWalletOpen: false,
        selectedPlot: null,
      };

    case PopupActions.welcomeClose:
      return {
        ...state,
        displayPopupCity: true,
        displayPopupWelcome: false,
        displayPopupAbout: false,
        selectedPlot: null,
      };

    case PopupActions.plotClose:
      return {
        ...state,
        displayPopupCity: true,
        displayPopupPlot: false,
        selectedPlot: null,
      };

    case PopupActions.plotSelect:
      return {
        displayPopupWelcome: false,
        displayPopupCity: false,
        displayPopupPlot: true,
        selectedPlot: action.payload,
      };

    default:
      throw new Error("Unhandled action type");
  }
};

export { initialState, reducer };
